// Configurations for v-chip and v-select options for status fields
// v-select needs options in { title, value } format
// v-chip use different color for different status
export const activeInactiveStatusOptions = [
  {
    value: 'ACTIVE',
    title: 'Active',
    color: 'teal-darken-1',
  },
  {
    value: 'INACTIVE',
    title: 'Inactive',
    color: 'grey-darken-1',
  },
];

export const companyStatusOptions = activeInactiveStatusOptions;
export const customerStatusOptions = activeInactiveStatusOptions;
export const productStatusOptions = activeInactiveStatusOptions;
export const taxStatusOptions = activeInactiveStatusOptions;
export const invoiceReminderStatusOptions = activeInactiveStatusOptions;

export const invoiceCreateStatusOptions = [
  {
    value: 'DRAFT',
    title: 'Draft',
    color: 'grey-darken-1',
  },
  {
    value: 'SENT',
    title: 'Sent',
    color: 'amber-darken-1',
  },
];

export const invoiceEditStatusOptions = [
  ...invoiceCreateStatusOptions,
  {
    value: 'VOID',
    title: 'Void',
    color: 'red-darken-2',
  },
];

const invoiceBackendStatusOptions = [
  {
    value: 'UNPAID',
    title: 'Unpaid', // JIKA invoice sudah "Partially Paid", tapi re-kalkulasi "paid_amount" di backend menjadi 0  karena ada update atau penghapusan Receipt
    color: 'purple-darken-1',
  },
  {
    value: 'PARTIALLY PAID',
    title: 'Partially Paid',
    color: 'blue-darken-1',
  },
  {
    value: 'FULLY PAID',
    title: 'Fully Paid',
    color: 'teal-darken-1',
  },
];

export const invoiceStatusOptions = [...invoiceEditStatusOptions, ...invoiceBackendStatusOptions];

// Already use title case from backend
export const invoiceStatusSummaryOptions = [
  {
    value: 'Open',
    color: 'blue-darken-1',
  },
  {
    value: 'In Progress',
    color: 'orange-darken-1',
  },
  {
    value: 'Closed',
    color: 'teal-darken-1',
    textColor: 'white',
  },
  {
    value: 'Void',
    color: 'grey-darken-1',
  },
];
